import { FlowConfigIdType } from '../types/otsConfig';
import { clientWithoutInterceptors } from '../utils/http';

export async function getStory(storyName: string): Promise<any> {
  const response = await clientWithoutInterceptors.get(`/api/stories/${storyName}`);
  return response.data;
}

export async function getOtsPages(pageName: string, extraParams?: any): Promise<any> {
  const response = await clientWithoutInterceptors.post(`/api/ots-pages/${pageName}`, { extraParams });
  return response.data;
}

export async function getIsOtsResultsStoryReady(flowConfigId: FlowConfigIdType): Promise<boolean> {
  const response = await clientWithoutInterceptors.get(`/api/ots-pages/${flowConfigId}/ready`);
  return response.data.isReady;
}

export async function getOtsSignupStoryByName(pageName: string): Promise<any> {
  const response = await clientWithoutInterceptors.get(`/api/no-auth/ots-signup-pages/${pageName}`);
  return response.data;
}
